module.exports = __webpack_public_path__ + "img/cloth_g3_pants-01.a79ff761.svg";